import { Flex } from 'components/Layout/helpers';
import React, { ReactElement, useState } from 'react';
import { Icon } from 'semantic';
import { Accordion, AccordionContent, AccordionTitle } from 'semantic-ui-react';

import './RadioAccordion.less';

export type RadioAccordionOption = {
  header: ReactElement;
  id: string;
  content: ReactElement;
};

type Props = {
  options: RadioAccordionOption[];
  onOptionSelected: (id: string) => void;
  optionSelected: string;
};

export function RadioAccordion({
  options,
  optionSelected,
  onOptionSelected,
}: Props) {
  return (
    <Accordion>
      {options.map((e) => {
        const selected = optionSelected === e.id;
        const selectionIcon = selected
          ? 'circle-check regular'
          : 'circle regular';
        return (
          <div
            className={`radio-accordion-item ${selected ? 'radio-accordion-item-active' : ''}`}
            key={e.id}>
            <AccordionTitle
              active={!!selected}
              onClick={() => {
                onOptionSelected?.(e.id);
              }}>
              <Flex justify="space-between" align="center">
                {e.header}
                <Icon size="large" name={selectionIcon} />
              </Flex>
            </AccordionTitle>
            <AccordionContent active={!!selected}>{e.content}</AccordionContent>
          </div>
        );
      })}
    </Accordion>
  );
}
